import { elementType, node, bool, string } from "prop-types";
export var propTypes = {
  as: elementType,
  className: string,
  children: node.isRequired,
  selected: bool
};